import { useParams } from 'react-router-dom';
import QuestionnaireViewer from '../components/questionnaire/QuestionnaireViewer';
import { Container } from 'react-bootstrap';
import { useRecordPageView } from '../hooks/useRecordPageView';

export default function Questionnaire() {
  const { templateId } = useParams<{ templateId: string }>();

  useRecordPageView();

  return (
    <Container>
      <QuestionnaireViewer templateId={templateId || ''} />
    </Container>
  );
}
